import axios from '@dap/shared-utils/http.js';

export default {
    createCreative (params) {
        return axios.post('/dapper/api/creative/tiktok', params);
    },
    checkName (params) {
        return axios.get('/dapper/api/creative/tiktok/check', { params });
    },
    getCallToAction () {
        return axios.get('/dapper/api/creative/tiktok/call_to_action');
    },
    getAdText (params) {
        return axios.get('/dapper/api/creative/tiktok/ad_text', { params });
    },
    changeStatus (params) {
        axios.put('/dapper/api/creative/tiktok/status', params);
    },
    getList (params) {
        return axios.get('/dapper/api/creative/tiktok/list', { params });
    },
    getDetail (params) {
        return axios.get('/dapper/api/creative/tiktok/detail', { params });
    },
    getLog (params) {
        return axios.get('/dapper/api/creative/tiktok/log', { params });
    },
    getCover (params) {
        return axios.get('/dapper/api/creative/tiktok/video_cover', { params });
    },
};
